export default function LoginRequired(){
  return (
    <div>
      Cannot access this content. Login required.
    </div>
  )
}
